import { create } from 'zustand'
import { persist } from 'zustand/middleware'
import { createSelectors } from '~/shared/lib/zustand-utils'
import { TABLE_COLUMNS, TABLE_COLUMNS_MAP, TABLE_SETTINGS_STORAGE_KEY } from '../config'

interface TableSettingsStore {
  hiddenColumns: (keyof typeof TABLE_COLUMNS_MAP)[]
  setHiddenColumns: (hiddenColumns: (keyof typeof TABLE_COLUMNS_MAP)[]) => void
}

const tableSettingsStore = createSelectors(
  create<TableSettingsStore>()(
    persist(
      (set) => ({
        hiddenColumns: [TABLE_COLUMNS.FLAGGED],
        setHiddenColumns: (hiddenColumns: (keyof typeof TABLE_COLUMNS_MAP)[]) =>
          set({ hiddenColumns }),
      }),
      { name: TABLE_SETTINGS_STORAGE_KEY },
    ),
  ),
)

export const useTableSettingsSelectors = () => {
  const hiddenColumns = tableSettingsStore.use.hiddenColumns()
  const setHiddenColumns = tableSettingsStore.use.setHiddenColumns()
  return { hiddenColumns, setHiddenColumns }
}
